// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "priority-3o3o8";
var _3 = "priorityBoardingModal-18Tjc";
var _4 = "header-1mjsq";
var _5 = "passenger-vDhA9";
var _6 = "label-3IUI7";
var _7 = "price-24-mR";
var _8 = "paper-10Weo";
export { _1 as "__esModule", _2 as "priority", _3 as "priorityBoardingModal", _4 as "header", _5 as "passenger", _6 as "label", _7 as "price", _8 as "paper" }
export default { "__esModule": _1, "priority": _2, "priorityBoardingModal": _3, "header": _4, "passenger": _5, "label": _6, "price": _7, "paper": _8 }
